import { Component, inject } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import Performer from '@account/Performer'
import { DialogComponent } from '@ui/Components/Dialog/Dialog.Component'
import { CreatePerformerComponent } from '@account/Components/Performers/Create/CreatePerformer.Component'

@Component({
	selector: 'create-performer-dialog',
	templateUrl: './CreatePerformerDialog.Component.html',
	imports: [DialogComponent, CreatePerformerComponent],
})
export class CreatePerformerDialogComponent {
	private readonly dialogRef: MatDialogRef<CreatePerformerDialogComponent>

	constructor() {
		this.dialogRef = inject(MatDialogRef<CreatePerformerDialogComponent>)
	}

	public closeDialog = (performer: Performer) => {
		this.dialogRef.close(performer)
	}
}
